import { useState, useEffect } from "react";
import useRequest from "../hooks/useRequest";
import apiPath from "../constants/apiPath";
import { Severty, ShowToast } from "../helper/toast";

export const ServiceAPIs = () => {
  const { request } = useRequest();

  const getChallenges = (setLoading, setData) => {
    setLoading(true);
    request({
      url: apiPath.getChallenges,
      method: "GET",
      onSuccess: (data) => {
        if (data.status) {
          setData(data.data);
          ShowToast(data.message, Severty.ERROR);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
        setLoading(false);
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err.message, Severty.ERROR);
      },
    });
  };

  const addChallenge = (setLoading, values, hide, refresh, data) => {
    const { title, category, description, duration, emoji } = values;
    const payload = { ...values };
    payload.title =  title.startsWith("I do") ? title : "I do " + title;
    payload.emoji = emoji;
    payload.category = category;
    payload.duration = duration;
    payload.description = description;
    setLoading(true);
    request({
      url: data ? apiPath.addChallenge + "/" + data?._id : apiPath.addChallenge,
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  const getEmojis = (setData, keyword) => {
    request({
      url: apiPath.getEmojis + `?keyword=${keyword}`,
      method: "GET",
      onSuccess: (data) => {
        setData(data.data);
      },
      onError: (error) => {
        console.log(error);
      },
    });
  };

  return { getChallenges, addChallenge, getEmojis };
};
